import React from 'react';

import styles from './RentalCabPrice.module.css';
import { CabRentalPrice } from '../../pages/runtime-typechecker';
import { AppContextConsumer } from '../../AppContext';
import { CASE_CAB_CARD } from '../../constants/omniture';
import { isWebView } from '../../utils/commonUtils';

type RentalCabPriceProps = {
  cabRentalPrices: CabRentalPrice[];
};

const RentalCabPrice = ({ cabRentalPrices }: RentalCabPriceProps) => {
  const redirect = omniUrlArgs => {
    const redirectionUrl = isWebView()
      ? `mmyt://react/?page=cabs&deeplink=true&tripType=OW&${omniUrlArgs}${CASE_CAB_CARD}`
      : `https://www.makemytrip.com/cabs?${omniUrlArgs}${CASE_CAB_CARD}`;

    window.location = Object(redirectionUrl);
  };
  return (
    <AppContextConsumer>
      {({ omniUrlArgs, trackTemplateEvent }) => {
        const redirectionUrl = `https://www.makemytrip.com/cabs?${omniUrlArgs}${CASE_CAB_CARD}`;
        return (
          <table
            style={{
              width: '100%',
              textAlign: 'left',
              border: '1px solid #cecece'
            }}
            className={`${styles.cabPriceWarp} ${styles.RentalCabPricesBorder}`}
          >
            <thead>
              <tr className={styles.priceRowHeader}>
                <th
                  style={{
                    width: '22%',
                    flex: 'none',
                    border: '1px solid #cecece'
                  }}
                  className={styles.priceCol}
                >
                  Vehicle Type
                </th>
                <th
                  style={{
                    width: '18%',
                    flex: 'none',
                    border: '1px solid #cecece'
                  }}
                  className={styles.priceCol}
                >
                  Model
                </th>
                <th
                  style={{
                    width: '15%',
                    flex: 'none',
                    border: '1px solid #cecece'
                  }}
                  className={styles.priceCol}
                >
                  Per Km Rate
                </th>
                <th
                  style={{
                    width: '15%',
                    flex: 'none',
                    border: '1px solid #cecece'
                  }}
                  className={styles.priceCol}
                >
                  Fare
                </th>
                <th
                  style={{
                    width: '15%',
                    flex: 'none',
                    border: '1px solid #cecece'
                  }}
                  className={styles.priceCol}
                >
                  Included
                </th>
                <th
                  style={{ width: '15%', flex: 'none' }}
                  className={`${styles.priceCol} ${styles.viewDtl}`}
                >
                  {''}
                  &nbsp;
                </th>
              </tr>
            </thead>
            <tbody>
              {cabRentalPrices.map((item, index) => (
                <tr key={index} className={styles.priceRow}>
                  <td
                    style={{
                      width: '22%',
                      flex: 'none',
                      border: '1px solid #cecece'
                    }}
                    className={`${styles.priceCol} latoBold blackText`}
                  >
                    {item.type.replace(/_/, ' ')}
                  </td>
                  <td
                    style={{
                      width: '18%',
                      flex: 'none',
                      border: '1px solid #cecece'
                    }}
                    className={styles.priceCol}
                  >
                    {item.vehicle_model} {item.similar_message}
                  </td>
                  <td
                    style={{
                      width: '15%',
                      flex: 'none',
                      border: '1px solid #cecece'
                    }}
                    className={styles.priceCol}
                  >
                    ₹{item.per_km_charge}
                  </td>
                  <td
                    style={{
                      width: '15%',
                      flex: 'none',
                      border: '1px solid #cecece'
                    }}
                    className={styles.priceCol}
                  >
                    ₹{item.total_amount}
                  </td>
                  <td
                    style={{
                      width: '15%',
                      flex: 'none',
                      border: '1px solid #cecece'
                    }}
                    className={styles.priceCol}
                  >
                    {item.included_kms} KMs
                  </td>
                  <td
                    style={{ flex: 'none', border: '1px solid #cecece' }}
                    className={styles.priceCol}
                  >
                    <a
                      style={{ borderLeft: 'none' }}
                      onClick={e => {
                        e.preventDefault();
                        trackTemplateEvent(
                          'Cab_SEO_City_Rental_Table_View_Details_Click'
                        );
                        redirect(omniUrlArgs);
                      }}
                      className={`${styles.priceCol} deepskyBlueText latoBold ${styles.viewDtl}`}
                      href={redirectionUrl}
                    >
                      {' '}
                      View Details
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      }}
    </AppContextConsumer>
  );
};

export default RentalCabPrice;
